import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

export const fetchUserData = createAsyncThunk(
  "category/fetchUserData",
  async (_, { rejectWithValue }) => {
    try {
      const fullUrl = `${baseUrl}/business/dashboard-filtered-details`;

      const response = await fetch(fullUrl);

      console.log("📡 RESPONSE STATUS:", response.status);

      if (!response.ok) {
        const text = await response.text();
        console.error("❌ API ERROR RESPONSE:", text);
        throw new Error(text || "Request failed");
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("❌ FETCH ERROR:", error.message);
      return rejectWithValue(error.message);
    }
  },
);

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    selectedMainCategory: null,
    selectedSubCategory: null,
    selectedLevel3: null,
    userData: [],
    loading: false,
    error: null,
  },
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    selectMainCategory: (state, action) => {
      state.selectedMainCategory = action.payload;
      state.selectedSubCategory = action.payload?.subCategories?.[0] || null;
      state.selectedLevel3 =
        state.selectedSubCategory?.subCategories?.[0] || null;
    },
    selectSubCategory: (state, action) => {
      state.selectedSubCategory = action.payload;
      state.selectedLevel3 = action.payload?.subCategories?.[0] || null;
    },
    selectLevel3: (state, action) => {
      state.selectedLevel3 = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  setCategories,
  selectMainCategory,
  selectSubCategory,
  selectLevel3,
} = categorySlice.actions;
export default categorySlice.reducer;
